import WorkspaceFolderTree from './WorkspaceFolderTree.vue';

import WorkspaceFolderTreeService from './WorkspaceFolderTreeService';

WorkspaceFolderTree.WorkspaceFolderTreeService = WorkspaceFolderTreeService;

export default WorkspaceFolderTree;
